import { Input } from "antd";
import classnames from "classnames";
import React, { useState } from "react";

import "./hover-editable-input.scss";

export const HoverEditableInput = (props) => {
  const { className } = props;
  const [isHover, setIsHover] = useState(false);
  return (
    <Input
      className={classnames({
        "hover-editable-input": true,
        hover: isHover,
        'un-hover': !isHover,
        className,
      })}
      onMouseEnter={() => setIsHover(true)}
      onMouseLeave={() => setIsHover(false)}
      {...props}
    />
  );
};



// WEBPACK FOOTER //
// ./src/containers/Video/widgets/hover-editable-input.js